import React from 'react';
import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { useSearchActionResolver, useSuggestionActionResolver, useRunDomainAction, useDomainActionStatus } from './hooks';
import { ActionsContext } from './context';
export const ActionsExtension = createModuleExtension({
  extensionName: 'actions',
  SDK: {
    useSearchActionResolver,
    useSuggestionActionResolver,
    useRunDomainAction,
    useDomainActionStatus
  },
  Provider: _ref => {
    let {
      siteInfo = {
        externalViewer: false
      },
      statusesOverrides = {},
      handlers = {},
      enabledActions = [],
      uiConfig = {},
      autoInvokeOverride,
      children
    } = _ref;
    return /*#__PURE__*/React.createElement(ActionsContext.Provider, {
      value: {
        statuses: statusesOverrides,
        siteInfo,
        handlers,
        enabledActions,
        uiConfig,
        autoInvokeOverride
      }
    }, children);
  }
});
//# sourceMappingURL=actions.extension.js.map